import BlockComponentMap from '../../../models/BlockComponentValues/BlockComponentMap';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockMapData {
  html: BlockComponentMap;
  text: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMapData {
  export function make(html?: string, text?: string, url?: string): BlockMapData {
    return {
      html: BlockComponentMap.make(html),
      text: text ? BlockComponentText.make(text) : undefined,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(html: string = undefined, text = '説明文'): BlockMapData {
    return make(html, text);
  }
}

export default BlockMapData;
